export default "__VITE_ASSET___wJ7qAGZ__"